import {Ref} from 'vue'
import {post} from "@/api/phone";
import {ElMessage, ElMessageBox} from "element-plus";

interface Tb {
    "idCardNo": string,
    "phone": string,
    "price": string,
    "transAmt": number,
    "rePayTime": string,
    "state": string,
    "type": number,
    "id": string,
    "reqSeqId": string,
    "reqDate": string,
    "isD": boolean,
    "create_time": string,
    "description": string,
}

function getCurrentTimeFormatted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export function useTable(tableData: Ref<Tb[]>, onSubmit: (data: Tb) => void) {

    const handleEdit = async (index: number, row: Tb) => {
        try {
            await ElMessageBox.confirm(
                '确定要执行编辑操作吗？',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            );

            console.log(index, row)
            console.log(row)
            if (row.type == 0) {
                try {
                    const transAmtFixed = Number(row.transAmt).toFixed(2);
                    const params = new URLSearchParams();
                    params.append('ord_amt', transAmtFixed);
                    params.append('org_req_seq_id', row.reqSeqId);
                    params.append('org_req_date', row.reqDate);
                    const response = await post('/hbank/promote_bank_back?' + params.toString(),
                        {});
                    console.log('提交成功:', response.data);
                    onSubmit(row)
                    if (response.code == 200) {
                        ElMessage.success('编辑成功');

                    } else {
                        ElMessage.error(response.msg);

                    }

                } catch (error) {
                    console.error('提交失败:', error);
                    ElMessage.error('编辑失败');
                }
            } else if (row.type == 1) {
                const formattedTime = getCurrentTimeFormatted();
                try {
                    const response = await post('/bank/promote_f_delete',
                        {
                            "trans_id": row.reqSeqId,
                            "refund_order_no": row.reqSeqId + formattedTime,
                            "refund_reason": "需要退款",
                            "refund_amt": row.transAmt,
                            "refund_time": formattedTime,
                            "refund_type": "8",
                            "trans_serial_no": row.reqSeqId + formattedTime,
                            "phone": row.phone
                        });

                    console.log('提交成功:', response.data);
                    onSubmit(row)
                    if (response.code == 200) {
                        ElMessage.success('编辑成功');

                    } else {
                        ElMessage.error(response.msg);

                    }

                } catch (error) {
                    console.error('提交失败:', error);
                    ElMessage.error('编辑失败');
                }
            }
        } catch (error) {
            ElMessage.info('已取消操作');
        }
    }

    const handleDelete = async (index: number, row: Tb) => {
        try {
            await ElMessageBox.confirm(
                '确定要执行编辑操作吗？此操作不可撤销！',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }
            );

            console.log(row)
            if (row.type == 0) {
                try {
                    const response = await post('/hbank/promote_bank_delet?phone=' + row.phone, {});
                    console.log('提交成功:', response.data);
                    onSubmit(row)
                    if (response.code == 200) {
                        ElMessage.success('编辑成功');

                    } else {
                        ElMessage.error(response.msg);

                    }

                } catch (error) {
                    console.error('提交失败:', error);
                    ElMessage.error('提交失败');
                }
            } else if (row.type == 1) {
                try {
                    const response = await post('/bank/promote_bank_delete?phone=' + row.phone, {});
                    console.log('提交成功:', response.data);
                    onSubmit(row)
                    if (response.code == 200) {
                        ElMessage.success('编辑成功');

                    } else {
                        ElMessage.error(response.msg);

                    }
                } catch (error) {
                    console.error('提交失败:', error);
                    ElMessage.error('提交失败');
                }
            }
        } catch (error) {
            ElMessage.info('已取消操作');
        }
    }
    const handleOder = async (index: number, row: Tb) => {


        try {
            await ElMessageBox.confirm(
                '确定要执行编辑操作吗？',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            );

            console.log(index, row)
            console.log(row)

            try {

                const response = await post('/user/reback/isdelete?phone=' + row.phone, {});
                console.log('提交成功:', response.data);
                onSubmit(row)
                if (response.code == 200) {
                    ElMessage.success('编辑成功');

                } else {
                    ElMessage.error(response.msg);

                }

            } catch (error) {
                console.error('提交失败:', error);
                ElMessage.error('编辑失败');
            }

        } catch (error) {
            ElMessage.info('已取消操作');
        }
    }

    return {handleEdit, handleDelete, handleOder}
}
